import { useCallback, useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'

import { useUserProjectRole } from 'portal/lib/hooks'
import { projectAlertsLoad } from 'portal/store/projectAlerts/actions'

export const useProjectAlertsLoader = (startDate, endDate) => {
  const dispatch = useDispatch()
  const { accountId, projectId } = useParams<{
    accountId: string
    projectId: string
  }>()

  const filter = useMemo(
    () => ({
      startDate,
      endDate
    }),
    [startDate, endDate]
  )

  const { isProjectAdmin } = useUserProjectRole(accountId, projectId)

  const reload = useCallback(() => {
    if (!accountId || !projectId) {
      return
    }
    dispatch(projectAlertsLoad(accountId, projectId, filter))
  }, [accountId, projectId, dispatch, filter])

  useEffect(() => {
    reload()
  }, [reload])

  const { loading, error, items } = useSelector((state: any) => {
    return state.projectAlerts
  })

  return {
    loading,
    error,
    items,
    reload,
    readOnly: !isProjectAdmin
  }
}
